// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".helper-overlay[data-v-d4ce4b98]{position:fixed;z-index:999;background:#f5f5f5;width:95vw;height:95vh;top:2vh;right:2vw;border:3px solid #3662ad;padding:10px;border-radius:5px;opacity:.5}.helper-overlay[data-v-d4ce4b98]:hover{opacity:1}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
